<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";

import simplebar from "simplebar-vue";



export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    /* eslint-disable vue/no-unused-components */
    simplebar,
    Layout,
    General: () => import('@/components/lazy/banmanager/General'),
    Pending: () => import('@/components/lazy/banmanager/Pending'),
  },
  data() {
    return {

    };
  },
  validations: {

  },
  methods: {

  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-flex align-items-center justify-content-between">
      <h4 class="mb-0 font-size-18">
        Ban Manager
      </h4>
      <div class="page-title-right bv-d-xs-down-none"><ol class="breadcrumb m-0">
        <li class="breadcrumb-item">
          <router-link to="/">
            <span class="text-danger text-uppercase">
              <i class="fad fa-clipboard-user" />
              CFTools Internal
            </span>
          </router-link>
        </li>
      </ol>
      </div>
    </div>
    <General/>
    <div class="row">
      <div class="col">
        <Pending/>
      </div>
    </div>
  </Layout>
</template>